<template>
  <div>

    <lk-modal v-model="value" title="修改密码" @on-cancel='handleCancel' :closable='false'
      @on-ok='handleConfirm' :mask-closable='false'>
      <lk-form :label-width='100' :model='passwordForm' ref="passwordForm" :rules='rules'
        :label-position='"right"'>
        <lk-row>
          <lk-form-item label='原密码:' prop='old'>
            <lk-input v-model="passwordForm.old" placeholder="请输入当前密码" class="input-password"
              :maxlength='20'></lk-input>
          </lk-form-item>
          <lk-form-item label='新密码:' prop='password'>
            <div class="newPw">

              <lk-input class="input-password" v-model="passwordForm.password"
                placeholder="可输入数字、大小写字母、特殊字符" :maxlength='20'></lk-input>
              <span :class="{'pwTester':true,'trans':!passwordForm.password}">
                <span v-for="(item,i) in 10" :class="{'testItem':true,'light':i<=level}"
                  :key="i"></span>
              </span>
            </div>
          </lk-form-item>
          <lk-form-item label='新密码确认:' prop='repeat'>
            <lk-input class="input-password" v-model="passwordForm.repeat" placeholder="请重复输入新密码"
              :maxlength='20'></lk-input>
          </lk-form-item>
        </lk-row>
      </lk-form>
      <div class="modalFooter" slot="footer">
        <lk-button @click="handleCancel">取消</lk-button>
        <lk-button type='primary' @click="handleConfirm">确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import system from '../services/system';
import user from '../services/user';
import utils from '../libs/utils';

export default {
  name: 'passwordModal',
  props: {
    val: {},
  },
  model: {
    event: 'change',
    prop: 'val',
  },
  data() {
    function checkOld(rule, value, callback) {
      system.passwordCheck({ old: value }).then((res) => {
        if (res.data.status === 200) {
          callback();
        } else {
          callback(new Error(res.data.error));
        }
      }).catch((err) => {
        callback();
        utils.handleError(err);
      });
      // callback();
    }
    const checkRepeat = (rule, value, callback) => {
      console.log(this);

      if (this.passwordForm.repeat === this.passwordForm.password) {
        callback();
      } else {
        callback(new Error('两次输入密码不一致'));
      }

      // callback();
    };
    return {
      value: false,
      // afterChange
      level: 10,
      rules: {
        old: [{ required: true, message: '请输入当前密码', trigger: 'blur' },
          {
            validator: checkOld, trigger: 'blur',
          }],
        password: [{ required: true, message: '请输入新密码' }],
        repeat: [
          { required: true, message: '请输入新密码确认' },
          { validator: checkRepeat, trigger: 'blur' }],
      },
      passwordForm: {

      },
    };
  },
  watch: {
    val(val) {
      this.value = val;
      // this.$emit('change', val);
    },
    passwordForm: {
      handler(val) {
        const pw = val.password;
        const lowTester1 = /^\d{6,}$/.test(pw);
        const lowTester2 = /^([A-Z]){6,}$/.test(pw);
        const lowTester3 = /^[a-z]{6,}$/.test(pw);
        const midTester1 = /^([a-z]|[A-Z]){6,}$/.test(pw);
        const midTester2 = /^([a-z]|\d){6,}$/.test(pw);
        const midTester3 = /^([A-Z]|\d){6,}$/.test(pw);
        const hightTester = /^([a-z]|[A-Z]|\d){6,}$/.test(pw);

        this.level = -1;
        if (lowTester1 || lowTester2 || lowTester3) {
          this.level = 3;
        } else if (midTester1 || midTester2 || midTester3) {
          this.level = 7;
        } else if (hightTester) {
          this.level = 10;
        }
      },
      deep: true,
    },
  },
  methods: {
    handleCancel() {
      this.$emit('change', false);
    },
    handleConfirm() {
      if (this.level < 7) {
        this.$Message.error('密码安全性过低请重新输入');
        return;
      }
      // this.$refs.passwordForm.validate((valid) => {
      //   if (valid) {
      const { old, password } = this.passwordForm;
      system.passwordChangeByOld({ old, password }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('修改成功，请重新登录');
          // user.logout().then((outRes) => {
          //   if (res.data.status === 200) {
          setTimeout(() => {
            window.location.reload(true);
          }, 500);
          //   } else {
          //     this.$Message.error(outRes.data.error);
          //   }
          // }).catch((err) => {
          //   utils.handleError(err);
          // });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
      //   }
      // });
    },

  },
};
</script>
<style lang="less" scoped>
.newPw{
position: relative;
  .pwTester{
position: absolute;
    // float: left;
    height: 5px;
    margin-top: 3px;
    width: 100%;
    display: flex;
    // align-items: center;
    .testItem{
      display: inline-block;
      height: 5px;
      width: 10%;
      background: #eee;
      margin-right: 2px;
    }
        .light{
          background: #42a400
        }
}
            .trans{
opacity: 0;
            }

}
</style>
